module.exports = __webpack_public_path__ + "static/img/payment.c831172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment.png
// module id = dCcM
// module chunks = 1